var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 5.5,
    stroke: "#F9B218"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6669 17.9147L16.9917 11.2396C16.8373 11.0851 16.6312 11 16.4114 11C16.1917 11 15.9856 11.0851 15.8312 11.2396L15.3396 11.7311C15.0197 12.0513 15.0197 12.5718 15.3396 12.8916L20.9449 18.4969L15.3334 24.1084C15.179 24.2629 15.0938 24.4689 15.0938 24.6885C15.0938 24.9084 15.179 25.1144 15.3334 25.269L15.825 25.7604C15.9795 25.9149 16.1854 26 16.4052 26C16.625 26 16.8311 25.9149 16.9854 25.7604L23.6669 19.0792C23.8216 18.9242 23.9066 18.7173 23.9061 18.4973C23.9066 18.2764 23.8216 18.0696 23.6669 17.9147Z",
    fill: "#F9B218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.1f71ad87cc37af4531ae06753e6eb406.svg";
export { ForwardRef as ReactComponent };